import { render, staticRenderFns } from "./InfoDiscountAddition.vue?vue&type=template&id=64218bbe"
import script from "./InfoDiscountAddition.vue?vue&type=script&lang=js"
export * from "./InfoDiscountAddition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports